<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc-bot"><a href="#/xhtml/map#map">Map</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">The Conan Saga</a></p>
<p class="toc-auth"><span class="epub-i">by L. Sprague de Camp</span></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">Legions of the Dead</a></p>
<p class="toc-auth"><span class="epub-i">by Lin Carter and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">The People of the Summit</span></p>
<p class="toc-auth"><span class="epub-i">by Björn Nyberg and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Shadows in the Dark</span></p>
<p class="toc-auth"><span class="epub-i">by Lin Carter and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">The Star of Khorala</span></p>
<p class="toc-auth"><span class="epub-i">by Björn Nyberg and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Gem in the Tower</span></p>
<p class="toc-auth"><span class="epub-i">by Lin Carter and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Ivory Goddess</span></p>
<p class="toc-auth"><span class="epub-i">by Lin Carter and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Moon of Blood</span></p>
<p class="toc-auth"><span class="epub-i">by Lin Carter and L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Hyborian Names</span></p>
<p class="toc-bot"><span class="epub-i">by L. Sprague de Camp</span></p>
<p class="toc"><span href="#/xhtml/adcard#acd" title="Link target outside of Sample">Chronological order of the Conan series</span></p>
<p class="toc"><span href="#/xhtml/abtauth#abt" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc"><span href="#/xhtml/copyright#cpy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?31c669b7